module.exports = __webpack_public_path__ + "static/img/cMRI4.5fee96d7.png";